module.exports = __webpack_public_path__ + "static/media/43.5876ad5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/43.svg
// module id = 152
// module chunks = 0